export default function getScrollPositionFromBottom() {
  const totalHeight = document.body.clientHeight;
  const scrollPosition = window.scrollY;
  const positionFromBottom = totalHeight - scrollPosition;
  return positionFromBottom;
}
